import { ActionType, Action, visitSummaryState } from "../actions/types"

const initialVisitState: visitSummaryState = {
  visitsummary: {}
}

const visitReducer = (
  state: visitSummaryState = initialVisitState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_VISIT_SUMMARY:
      return {
        ...state,
        visitsummary: action.payload
      }
    default:
      return state
  }
}

export default visitReducer
